import { Fab as UiFab, Typography as UiTypography, styled } from "@mui/material"

const SIZE = 44

export const Fab = styled(UiFab)(({ theme }) => ({
    position: "relative",
    width: SIZE,
    height: SIZE,
    boxShadow: theme.customShadow("LCS/Shadow-simple"),
}))

export const FilterCount = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.common.black,
    borderRadius: "50%",
    position: "absolute",
    right: 0,
    top: 0,
    transform: "translateX(35%) translateY(-35%)",
    width: 20,
    height: 20,
}))

export const Typography = styled(UiTypography)(({ theme }) => ({
    color: theme.palette.common.white,
}))